import React from 'react';
import { Box, Typography, Button, Stack } from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet-async';
import lukySad from '../assets/luky-sad-404.png';
import { LukaLogoIcon } from '../components/onboarding-icons';


const NotFoundPage: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { brandKeyword } = useParams();

  return (
    <>
      <Helmet>
        <title>404 - Página no encontrada</title>
        <link rel="icon" href="/favicon.png" type="image/png" />
      </Helmet>
      <Box
        sx={{
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          p: 3,
          bgcolor: '#FFFFFF'
        }}
      >
        <Stack spacing={4} alignItems="center" maxWidth={600}>
          {/* Logo Luka */}
          <Box sx={{ mb: 2 }}>
            <LukaLogoIcon style={{ width: 120, height: 'auto' }} />
          </Box>

          {/* Ilustración de Luky triste */}
          <Box
            component="img"
            src={lukySad}
            alt="Luky triste"
            sx={{
              width: { xs: 200, sm: 280 },
              height: 'auto',
              mb: 2
            }}
          />

          {/* Título 404 */}
          <Typography
            variant="h1"
            sx={{
              fontSize: { xs: '4rem', sm: '6rem' },
              fontWeight: 800,
              color: 'primary.main',
              lineHeight: 1,
              mb: 1
            }}
          >
            404
          </Typography>

          {/* Mensaje */}
          <Typography
            variant="h5"
            fontWeight="600"
            textAlign="center"
            color="text.primary"
            sx={{ mb: 1 }}
          >
            {brandKeyword 
              ? `La marca "${brandKeyword}" no fue encontrada`
              : 'Página no encontrada'
            }
          </Typography>
          
          <Typography
            variant="body1"
            color="text.secondary"
            textAlign="center"
            sx={{ maxWidth: 400 }}
          >
            {brandKeyword
              ? 'Lo sentimos, la marca que buscas no existe o no está disponible en este momento.'
              : 'Lo sentimos, la página que buscas no existe o fue movida.'
            }
          </Typography>

          {/* Botón */}
          <Button
            variant="contained"
            size="large"
            onClick={() => window.location.href = 'https://somosluka.com'}
            sx={{
              mt: 2,
              px: 4,
              py: 1.5,
              borderRadius: 2,
              textTransform: 'none',
              fontSize: '1rem',
              fontWeight: 600
            }}
          >
            Ir al inicio
          </Button>
        </Stack>
      </Box>
    </>
  );
};

export default NotFoundPage;
